import React, { FC }                from 'react';
import { Form, useFormikContext }   from 'formik';
import { Box }                      from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import { IFeeValues }               from '@typings/accountManagement';
import { IBulkPricingList }         from '@typings/invoiceManagement';
import { Button           }         from '@components/index';
import {
  CheckboxFieldGroup,
  ICheckboxOption,
}                                   from '@components/Checkbox/CheckboxFieldGroup';

const BulkWrapper = withStyles(({ breakpoints }) => createStyles({
  root: {
    display   : 'flex',
    marginTop : '30px',

    [breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}))(Box);

interface IBulkAccount {
  feesValues           : IFeeValues[];
  defaultPricing       : ICheckboxOption[];
  organizationsOptions : ICheckboxOption[];
  handleUpdateBulkFees : (feesValues: IFeeValues[], accountList: IBulkPricingList) => void;
  toggleModal          : () => void;
}

export const BulkAccountsForm: FC<IBulkAccount> = ({
  defaultPricing,
  organizationsOptions,
  toggleModal,
}) => {
  const {
    values,
    isValid,
    dirty,
    isSubmitting,
    setFieldValue,
  } = useFormikContext<IBulkPricingList>();

  return (
    <Form>
      <BulkWrapper>
        <div>
          <CheckboxFieldGroup
            bulkLabel     = "Accounts"
            groupName     = "accounts"
            options       = {organizationsOptions}
            values        = {values.accounts}
            setFieldValue = {setFieldValue}
          />
        </div>

        <div>
          <CheckboxFieldGroup
            bulkLabel     = "Fees"
            groupName     = "fees"
            options       = {defaultPricing}
            values        = {values.fees}
            setFieldValue = {setFieldValue}
          />
        </div>
      </BulkWrapper>

      <Box
        display        = "flex"
        justifyContent = "end"
        marginTop      = "10px"
      >
        <Button
          label   = "Close"
          variant = "outlined"
          onClick = {toggleModal}
        />

        <Button
          type      = "submit"
          label     = "Apply"
          isLoading = {isSubmitting}
          disabled  = {isSubmitting || !isValid || !dirty}
        />
      </Box>
    </Form>
  );
};
